export default {
  //获取用户信息列表
  GET_LIST_USER: '/jcnapi/system/user/getList',
  //获取域名信息列表
  GET_LIST_MAIN: '/jcnapi/system/domain/getList',
  //保存用户
  SAVE: '/jcnapi/system/user/add',
  //修改密码
  RESET_PWD: '/jcnapi/system/user/edit'
}



// WEBPACK FOOTER //
// ./src/data/apiUrl/modules/userManagement/index.js